var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { IsArray, IsBoolean, IsEnum, IsString, IsOptional, IsObject, ValidateNested, IsDate, IsNumber } from "class-validator";
import { Type } from "class-transformer";
import { PickType } from "@nestjs/swagger";
export const TIMELINE_TYPE_ALL = "ALL";
export var UnitSystem;
(function (UnitSystem) {
    UnitSystem["US"] = "US";
    UnitSystem["METRIC"] = "METRIC";
})(UnitSystem || (UnitSystem = {}));
export var HealthWalletRecordSource;
(function (HealthWalletRecordSource) {
    HealthWalletRecordSource["FROM_RECORDS"] = "FROM_RECORDS";
})(HealthWalletRecordSource || (HealthWalletRecordSource = {}));
export var ProvenanceSource;
(function (ProvenanceSource) {
    ProvenanceSource["CLINICAL_RECORDS"] = "Clinical Records";
})(ProvenanceSource || (ProvenanceSource = {}));
export var HealthWalletRecordType;
(function (HealthWalletRecordType) {
    HealthWalletRecordType["VISIT"] = "VISIT";
    HealthWalletRecordType["PROCEDURE"] = "PROCEDURE";
    HealthWalletRecordType["GAP"] = "GAP";
})(HealthWalletRecordType || (HealthWalletRecordType = {}));
export var VisitType;
(function (VisitType) {
    VisitType["PRIMARY_CARE"] = "PRIMARY_CARE";
    VisitType["SPECIALIST"] = "SPECIALIST";
    VisitType["ANNUAL_PHYSICAL"] = "ANNUAL_PHYSICAL";
    VisitType["URGENT_CARE"] = "URGENT_CARE";
    VisitType["EMERGENCY"] = "EMERGENCY";
    VisitType["MENTAL_HEALTH"] = "MENTAL_HEALTH";
    VisitType["PSYCHIATRY"] = "PSYCHIATRY";
    VisitType["DENTAL"] = "DENTAL";
    VisitType["VISION"] = "VISION";
    VisitType["PHYSICAL_THERAPY"] = "PHYSICAL_THERAPY";
    VisitType["ALTERNATIVE_CARE"] = "ALTERNATIVE_CARE";
    VisitType["OBSTETRICS"] = "OBSTETRICS";
})(VisitType || (VisitType = {}));
export var ProcedureType;
(function (ProcedureType) {
    ProcedureType["LAB_DRAW"] = "LAB_DRAW";
    ProcedureType["IMAGING"] = "IMAGING";
    ProcedureType["GENETIC_TEST"] = "GENETIC_TEST";
    ProcedureType["SLEEP_STUDY"] = "SLEEP_STUDY";
    ProcedureType["COLONOSCOPY_ENDOSCOPY"] = "COLONOSCOPY_ENDOSCOPY";
    ProcedureType["CARDIAC_STRESS_TEST"] = "CARDIAC_STRESS_TEST";
    ProcedureType["BIOPSY"] = "BIOPSY";
    ProcedureType["MINOR_PROCEDURE"] = "MINOR_PROCEDURE";
    ProcedureType["EVALUATION_AND_MANAGEMENT"] = "EVALUATION_AND_MANAGEMENT";
    ProcedureType["SURGERY"] = "SURGERY";
    ProcedureType["VACCINATION"] = "VACCINATION";
    ProcedureType["ALLERGY_TESTING"] = "ALLERGY_TESTING";
    ProcedureType["PULMONARY_FUNCTION_TEST"] = "PULMONARY_FUNCTION_TEST";
    ProcedureType["INFUSION"] = "INFUSION";
})(ProcedureType || (ProcedureType = {}));
export class HealthWalletRecordBase {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsEnum(HealthWalletRecordType)
], HealthWalletRecordBase.prototype, "type", void 0);
export class HealthWalletHealthRecordBase extends HealthWalletRecordBase {
    constructor(fields) {
        super(fields);
        Object.assign(this, fields);
    }
}
__decorate([
    IsString()
], HealthWalletHealthRecordBase.prototype, "id", void 0);
__decorate([
    IsDate(),
    Type(() => Date),
    IsOptional()
], HealthWalletHealthRecordBase.prototype, "date", void 0);
__decorate([
    IsString(),
    IsOptional()
], HealthWalletHealthRecordBase.prototype, "providerName", void 0);
__decorate([
    IsString(),
    IsOptional()
], HealthWalletHealthRecordBase.prototype, "practiceName", void 0);
__decorate([
    IsString(),
    IsOptional()
], HealthWalletHealthRecordBase.prototype, "name", void 0);
__decorate([
    IsString(),
    IsOptional()
], HealthWalletHealthRecordBase.prototype, "description", void 0);
__decorate([
    IsEnum(HealthWalletRecordSource),
    IsOptional()
], HealthWalletHealthRecordBase.prototype, "source", void 0);
export class HealthWalletHealthRecordLiteDto extends PickType(HealthWalletHealthRecordBase, ["type", "id", "date"]) {
    constructor(fields) {
        super(fields);
        Object.assign(this, fields);
    }
}
export class HealthWalletTimelineItemVisit extends HealthWalletHealthRecordBase {
    constructor(fields) {
        super(fields);
        this.type = HealthWalletRecordType.VISIT;
        Object.assign(this, fields);
    }
}
__decorate([
    IsEnum(HealthWalletRecordType)
], HealthWalletTimelineItemVisit.prototype, "type", void 0);
__decorate([
    IsEnum(VisitType)
], HealthWalletTimelineItemVisit.prototype, "visitType", void 0);
export class HealthWalletTimelineItemProcedure extends HealthWalletHealthRecordBase {
    constructor(fields) {
        super(fields);
        this.type = HealthWalletRecordType.PROCEDURE;
        Object.assign(this, fields);
    }
}
__decorate([
    IsEnum(HealthWalletRecordType)
], HealthWalletTimelineItemProcedure.prototype, "type", void 0);
__decorate([
    IsEnum(ProcedureType)
], HealthWalletTimelineItemProcedure.prototype, "procedureType", void 0);
export class HealthWalletTimelineItemGap extends HealthWalletRecordBase {
    constructor(fields) {
        super(fields);
        this.type = HealthWalletRecordType.GAP;
        Object.assign(this, fields);
    }
}
__decorate([
    IsEnum(HealthWalletRecordType)
], HealthWalletTimelineItemGap.prototype, "type", void 0);
__decorate([
    Type(() => HealthWalletHealthRecordLiteDto),
    ValidateNested()
], HealthWalletTimelineItemGap.prototype, "previousRecord", void 0);
__decorate([
    Type(() => HealthWalletHealthRecordLiteDto),
    ValidateNested()
], HealthWalletTimelineItemGap.prototype, "nextRecord", void 0);
export class HealthWalletTimelineCounts {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsNumber()
], HealthWalletTimelineCounts.prototype, "total", void 0);
__decorate([
    IsObject()
], HealthWalletTimelineCounts.prototype, "visitTypes", void 0);
__decorate([
    IsObject()
], HealthWalletTimelineCounts.prototype, "procedureTypes", void 0);
export class HealthWalletTimelineDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    Type(() => HealthWalletRecordBase, {
        discriminator: {
            property: "type",
            subTypes: [
                { value: HealthWalletTimelineItemVisit, name: HealthWalletRecordType.VISIT },
                { value: HealthWalletTimelineItemProcedure, name: HealthWalletRecordType.PROCEDURE },
                { value: HealthWalletTimelineItemGap, name: HealthWalletRecordType.GAP },
            ],
        },
    }),
    ValidateNested({ each: true })
], HealthWalletTimelineDto.prototype, "records", void 0);
__decorate([
    IsOptional(),
    ValidateNested(),
    Type(() => HealthWalletTimelineCounts)
], HealthWalletTimelineDto.prototype, "counts", void 0);
__decorate([
    IsNumber()
], HealthWalletTimelineDto.prototype, "limit", void 0);
__decorate([
    IsNumber()
], HealthWalletTimelineDto.prototype, "offset", void 0);
__decorate([
    IsBoolean()
], HealthWalletTimelineDto.prototype, "hasMore", void 0);
__decorate([
    IsNumber(),
    IsOptional()
], HealthWalletTimelineDto.prototype, "connectedSources", void 0);
export class HealthWalletReason {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsString()
], HealthWalletReason.prototype, "display", void 0);
__decorate([
    IsString(),
    IsOptional()
], HealthWalletReason.prototype, "code", void 0);
export var HealthWalletPhysicianRole;
(function (HealthWalletPhysicianRole) {
    HealthWalletPhysicianRole["PRIMARY"] = "PRIMARY";
    HealthWalletPhysicianRole["SECONDARY"] = "SECONDARY";
})(HealthWalletPhysicianRole || (HealthWalletPhysicianRole = {}));
export class HealthWalletPhysician {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsString()
], HealthWalletPhysician.prototype, "name", void 0);
__decorate([
    IsString(),
    IsOptional()
], HealthWalletPhysician.prototype, "specialty", void 0);
__decorate([
    IsEnum(HealthWalletPhysicianRole),
    IsOptional()
], HealthWalletPhysician.prototype, "role", void 0);
export class HealthWalletPractice {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsString()
], HealthWalletPractice.prototype, "name", void 0);
__decorate([
    IsString(),
    IsOptional()
], HealthWalletPractice.prototype, "address", void 0);
export class HealthWalletDetailsProviderSection {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    Type(() => HealthWalletPhysician),
    ValidateNested({ each: true }),
    IsOptional()
], HealthWalletDetailsProviderSection.prototype, "physicians", void 0);
__decorate([
    Type(() => HealthWalletPractice),
    ValidateNested(),
    IsOptional()
], HealthWalletDetailsProviderSection.prototype, "practice", void 0);
__decorate([
    Type(() => HealthWalletReason),
    ValidateNested({ each: true }),
    IsOptional()
], HealthWalletDetailsProviderSection.prototype, "reasons", void 0);
export var HealthWalletMeasurementSource;
(function (HealthWalletMeasurementSource) {
    HealthWalletMeasurementSource["VITAL"] = "VITAL";
    HealthWalletMeasurementSource["LAB"] = "LAB";
    HealthWalletMeasurementSource["IMAGING"] = "IMAGING";
})(HealthWalletMeasurementSource || (HealthWalletMeasurementSource = {}));
export var MeasurementInsightRangeStatus;
(function (MeasurementInsightRangeStatus) {
    MeasurementInsightRangeStatus["NORMAL"] = "normal";
    MeasurementInsightRangeStatus["BORDERLINE"] = "borderline";
    MeasurementInsightRangeStatus["ABNORMAL"] = "abnormal";
    MeasurementInsightRangeStatus["CRITICAL"] = "critical";
})(MeasurementInsightRangeStatus || (MeasurementInsightRangeStatus = {}));
export var MeasurementInsightRangeDirection;
(function (MeasurementInsightRangeDirection) {
    MeasurementInsightRangeDirection["HIGH"] = "high";
    MeasurementInsightRangeDirection["LOW"] = "low";
})(MeasurementInsightRangeDirection || (MeasurementInsightRangeDirection = {}));
export class HealthWalletMeasurement {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsString(),
    IsOptional()
], HealthWalletMeasurement.prototype, "observationId", void 0);
__decorate([
    IsString()
], HealthWalletMeasurement.prototype, "name", void 0);
__decorate([
    IsString(),
    IsOptional()
], HealthWalletMeasurement.prototype, "value", void 0);
__decorate([
    IsEnum(HealthWalletMeasurementSource)
], HealthWalletMeasurement.prototype, "source", void 0);
__decorate([
    IsEnum(MeasurementInsightRangeStatus),
    IsOptional()
], HealthWalletMeasurement.prototype, "insightRangeStatus", void 0);
__decorate([
    IsString(),
    IsOptional()
], HealthWalletMeasurement.prototype, "referenceRange", void 0);
__decorate([
    IsBoolean()
], HealthWalletMeasurement.prototype, "hasInsight", void 0);
__decorate([
    IsBoolean()
], HealthWalletMeasurement.prototype, "hasReferenceRanges", void 0);
export class HealthWalletDetailsWhatWasMeasuredSection {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    Type(() => HealthWalletMeasurement),
    ValidateNested({ each: true })
], HealthWalletDetailsWhatWasMeasuredSection.prototype, "measurements", void 0);
export class MeasurementInsightRange {
}
__decorate([
    IsString()
], MeasurementInsightRange.prototype, "display", void 0);
__decorate([
    IsString()
], MeasurementInsightRange.prototype, "label", void 0);
__decorate([
    IsEnum(MeasurementInsightRangeStatus)
], MeasurementInsightRange.prototype, "status", void 0);
__decorate([
    IsOptional(),
    IsEnum(MeasurementInsightRangeDirection)
], MeasurementInsightRange.prototype, "direction", void 0);
__decorate([
    IsOptional(),
    IsNumber()
], MeasurementInsightRange.prototype, "low", void 0);
__decorate([
    IsOptional(),
    IsNumber()
], MeasurementInsightRange.prototype, "high", void 0);
__decorate([
    IsOptional(),
    IsBoolean()
], MeasurementInsightRange.prototype, "isCurrent", void 0);
export class MeasurementInsightDto {
}
__decorate([
    IsString()
], MeasurementInsightDto.prototype, "loincCode", void 0);
__decorate([
    IsString()
], MeasurementInsightDto.prototype, "name", void 0);
__decorate([
    IsString()
], MeasurementInsightDto.prototype, "category", void 0);
__decorate([
    IsString()
], MeasurementInsightDto.prototype, "simpleDescription", void 0);
__decorate([
    IsString()
], MeasurementInsightDto.prototype, "whyItMatters", void 0);
__decorate([
    Type(() => MeasurementInsightRange),
    ValidateNested({ each: true })
], MeasurementInsightDto.prototype, "referenceRanges", void 0);
__decorate([
    IsString(),
    IsOptional()
], MeasurementInsightDto.prototype, "observedValue", void 0);
__decorate([
    IsString(),
    IsOptional()
], MeasurementInsightDto.prototype, "observedValueUnit", void 0);
__decorate([
    IsString(),
    IsOptional()
], MeasurementInsightDto.prototype, "observedName", void 0);
export class VaccinationInsightDto {
}
__decorate([
    IsString()
], VaccinationInsightDto.prototype, "cvxCode", void 0);
__decorate([
    IsString()
], VaccinationInsightDto.prototype, "name", void 0);
__decorate([
    IsString()
], VaccinationInsightDto.prototype, "simpleDescription", void 0);
__decorate([
    IsString()
], VaccinationInsightDto.prototype, "whyItMatters", void 0);
__decorate([
    IsString(),
    IsOptional()
], VaccinationInsightDto.prototype, "efficacy", void 0);
__decorate([
    IsArray(),
    IsString({ each: true })
], VaccinationInsightDto.prototype, "commonSideEffects", void 0);
__decorate([
    IsString(),
    IsOptional()
], VaccinationInsightDto.prototype, "scheduleNote", void 0);
export var HealthWalletDocumentSource;
(function (HealthWalletDocumentSource) {
    HealthWalletDocumentSource["DOCUMENT_REFERENCE"] = "DOCUMENT_REFERENCE";
    HealthWalletDocumentSource["DIAGNOSTIC_REPORT"] = "DIAGNOSTIC_REPORT";
})(HealthWalletDocumentSource || (HealthWalletDocumentSource = {}));
export class HealthWalletDocument {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsString()
], HealthWalletDocument.prototype, "id", void 0);
__decorate([
    IsString()
], HealthWalletDocument.prototype, "name", void 0);
__decorate([
    IsEnum(HealthWalletDocumentSource)
], HealthWalletDocument.prototype, "source", void 0);
__decorate([
    IsString()
], HealthWalletDocument.prototype, "contentType", void 0);
__decorate([
    IsDate(),
    Type(() => Date),
    IsOptional()
], HealthWalletDocument.prototype, "date", void 0);
__decorate([
    IsNumber(),
    IsOptional()
], HealthWalletDocument.prototype, "sizeInBytes", void 0);
export const HUMAN_READABLE_CONTENT_TYPES = new Set([
    "application/pdf",
    "application/x-pdf",
    "text/plain",
    "text/rtf",
    "application/rtf",
    "text/html",
    "application/xhtml+xml",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.ms-powerpoint",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "text/csv",
    "image/jpeg",
    "image/jpg",
    "image/png",
    "image/gif",
    "image/webp",
    "image/tiff",
    "image/bmp",
]);
export const SANDBOXED_HTML_CONTENT_TYPES = new Set(["text/html", "application/xhtml+xml"]);
export const BROWSER_DISPLAYABLE_CONTENT_TYPES = new Set([
    "application/pdf",
    "application/x-pdf",
    "text/plain",
    "text/html",
    "application/xhtml+xml",
    "image/jpeg",
    "image/jpg",
    "image/png",
    "image/gif",
    "image/webp",
]);
export function isBrowserDisplayableContentType(contentType) {
    return BROWSER_DISPLAYABLE_CONTENT_TYPES.has(contentType.split(";")[0].trim().toLowerCase());
}
export function isSandboxedHtmlContentType(contentType) {
    return SANDBOXED_HTML_CONTENT_TYPES.has(contentType.split(";")[0].trim().toLowerCase());
}
export function isInlineDownloadContentType(contentType) {
    return isBrowserDisplayableContentType(contentType) && !isSandboxedHtmlContentType(contentType);
}
export function isHumanReadableContentType(contentType) {
    return HUMAN_READABLE_CONTENT_TYPES.has(contentType.split(";")[0].trim().toLowerCase());
}
export class HealthWalletDetailsDocumentsSection {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    Type(() => HealthWalletDocument),
    ValidateNested({ each: true })
], HealthWalletDetailsDocumentsSection.prototype, "documents", void 0);
export class HealthWalletDetailsProvenanceSection {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsEnum(ProvenanceSource),
    IsOptional()
], HealthWalletDetailsProvenanceSection.prototype, "source", void 0);
__decorate([
    IsString(),
    IsOptional()
], HealthWalletDetailsProvenanceSection.prototype, "organizationName", void 0);
__decorate([
    IsDate(),
    Type(() => Date),
    IsOptional()
], HealthWalletDetailsProvenanceSection.prototype, "lastUpdatedAt", void 0);
__decorate([
    IsDate(),
    Type(() => Date),
    IsOptional()
], HealthWalletDetailsProvenanceSection.prototype, "lastViewedAt", void 0);
export class HealthWalletDetailsHealthRecordBase extends HealthWalletHealthRecordBase {
    constructor(fields) {
        super(fields);
        Object.assign(this, fields);
    }
}
__decorate([
    Type(() => HealthWalletDetailsProviderSection),
    ValidateNested(),
    IsOptional()
], HealthWalletDetailsHealthRecordBase.prototype, "provider", void 0);
__decorate([
    Type(() => HealthWalletDetailsWhatWasMeasuredSection),
    ValidateNested(),
    IsOptional()
], HealthWalletDetailsHealthRecordBase.prototype, "whatWasMeasured", void 0);
__decorate([
    Type(() => HealthWalletDetailsDocumentsSection),
    ValidateNested(),
    IsOptional()
], HealthWalletDetailsHealthRecordBase.prototype, "documents", void 0);
__decorate([
    Type(() => HealthWalletDetailsProvenanceSection),
    ValidateNested(),
    IsOptional()
], HealthWalletDetailsHealthRecordBase.prototype, "provenance", void 0);
export class HealthWalletDetailsVisit extends HealthWalletDetailsHealthRecordBase {
    constructor(fields) {
        super(fields);
        this.type = HealthWalletRecordType.VISIT;
        Object.assign(this, fields);
    }
}
__decorate([
    IsEnum(HealthWalletRecordType)
], HealthWalletDetailsVisit.prototype, "type", void 0);
__decorate([
    IsEnum(VisitType)
], HealthWalletDetailsVisit.prototype, "visitType", void 0);
export class HealthWalletDetailsProcedure extends HealthWalletDetailsHealthRecordBase {
    constructor(fields) {
        super(fields);
        this.type = HealthWalletRecordType.PROCEDURE;
        Object.assign(this, fields);
    }
}
__decorate([
    IsEnum(HealthWalletRecordType)
], HealthWalletDetailsProcedure.prototype, "type", void 0);
__decorate([
    IsEnum(ProcedureType)
], HealthWalletDetailsProcedure.prototype, "procedureType", void 0);
__decorate([
    IsBoolean(),
    IsOptional()
], HealthWalletDetailsProcedure.prototype, "hasInsight", void 0);
__decorate([
    IsString(),
    IsOptional()
], HealthWalletDetailsProcedure.prototype, "vaccinationName", void 0);
export var HealthWalletGapReasonType;
(function (HealthWalletGapReasonType) {
    HealthWalletGapReasonType["RECORDS_DIDNT_TRANSFER"] = "RECORDS_DIDNT_TRANSFER";
    HealthWalletGapReasonType["SAW_DIFFERENT_PROVIDER"] = "SAW_DIFFERENT_PROVIDER";
    HealthWalletGapReasonType["USED_TELEHEALTH"] = "USED_TELEHEALTH";
    HealthWalletGapReasonType["WAS_LIVING_ABROAD"] = "WAS_LIVING_ABROAD";
    HealthWalletGapReasonType["NO_VISITS_DURING_THIS_TIME"] = "NO_VISITS_DURING_THIS_TIME";
    HealthWalletGapReasonType["SOMETHING_ELSE"] = "SOMETHING_ELSE";
})(HealthWalletGapReasonType || (HealthWalletGapReasonType = {}));
export var HealthWalletDetailsRecordType;
(function (HealthWalletDetailsRecordType) {
    HealthWalletDetailsRecordType["VISIT"] = "VISIT";
    HealthWalletDetailsRecordType["PROCEDURE"] = "PROCEDURE";
})(HealthWalletDetailsRecordType || (HealthWalletDetailsRecordType = {}));
export class DismissGapDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    Type(() => HealthWalletHealthRecordLiteDto),
    ValidateNested()
], DismissGapDto.prototype, "previousRecord", void 0);
__decorate([
    Type(() => HealthWalletHealthRecordLiteDto),
    ValidateNested()
], DismissGapDto.prototype, "nextRecord", void 0);
__decorate([
    IsArray(),
    IsEnum(HealthWalletGapReasonType, { each: true })
], DismissGapDto.prototype, "reasons", void 0);
